webpackJsonp([425],{

/***/ 1745:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(930),
  /* template */
  __webpack_require__(2394),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/manual-usage-167.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] manual-usage-167.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-94556072", Component.options)
  } else {
    hotAPI.reload("data-v-94556072", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2394:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("手动配置使用")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/tree/v2/packages/vue-cli-3-example"
    }
  }, [_vm._v("https://github.com/airyland/vux/tree/v2/packages/vue-cli-3-example")])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("注意的是下面事项并非表示 VUX 使用繁琐，部分只是出于确保有正确的依赖和配置，而部分是出于优化。")])]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("请将 "), _c('code', [_vm._v("babel-loader")]), _vm._v(" 的配置写到 "), _c('code', [_vm._v(".babelrc")]), _vm._v(" 里而不是使用 "), _c('code', [_vm._v("options")]), _vm._v("，否则可能会出错。")])]), _vm._v(" "), _c('p', [_vm._v("折腾能力强的同学参考一下，下面即"), _c('code', [_vm._v("airyland/vux2")]), _vm._v("模板主要处理的事项:")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("引入 "), _c('code', [_vm._v("reset.less")]), _vm._v("，默认样式不包含reset，并且部分用户自己有一套reset样式，因此需要在"), _c('code', [_vm._v("App.vue")]), _vm._v("进行手动引入")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("lang")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"less\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }, [_vm._v("\n@import '~vux/src/styles/reset.less';\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(">")]), _vm._v("\n")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("配置 "), _c('code', [_vm._v("vue-loader")]), _vm._v("（通过配置vux-loader实现）")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// vux-loader")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("module")]), _vm._v(".exports = {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("configureWebpack")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("config")]), _vm._v(" =>")]), _vm._v(" {\n    "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'@vux/loader'")]), _vm._v(").merge(config, {\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("plugins")]), _vm._v(": ["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-ui'")]), _vm._v(", {\n          "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'less-theme'")]), _vm._v(",\n          "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("path")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src/theme.less'")]), _vm._v("\n        }]\n    })\n  }\n}\n")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("配置"), _c('code', [_vm._v("babel-loader")]), _vm._v("以正确编译 VUX 的js源码（通过配置vux-loader实现）")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("module")]), _vm._v(".exports = {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("configureWebpack")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("config")]), _vm._v(" =>")]), _vm._v(" {\n    "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'@vux/loader'")]), _vm._v(").merge(config, {\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("plugins")]), _vm._v(": ["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-ui'")]), _vm._v(", {\n          "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'less-theme'")]), _vm._v(",\n          "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("path")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src/theme.less'")]), _vm._v("\n        }]\n    })\n  }\n}\n")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("安装"), _c('code', [_vm._v("less-loader")]), _vm._v("以正确编译less源码")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install less less-loader --save-dev\n")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("安装 "), _c('code', [_vm._v("yaml-loader")]), _vm._v(" 以正确进行语言文件读取")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install yaml-loader --save-dev\n")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("添加 "), _c('code', [_vm._v("viewport")]), _vm._v(" meta")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("meta")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"viewport\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"width=device-width,initial-scale=1,user-scalable=0\"")]), _vm._v(">")]), _vm._v("\n")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("添加 "), _c('code', [_vm._v("Fastclick")]), _vm._v(" 移除移动端点击延迟")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" FastClick = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'fastclick'")]), _vm._v(")\nFastClick.attach("), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("document")]), _vm._v(".body)\n")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("添加 "), _c('code', [_vm._v("vue-router")]), _vm._v("（如果不需要前端路由，可忽略）")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" VueRouter "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vue-router'")]), _vm._v("\nVue.use(VueRouter)\n")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("添加 webpack plugin, 在构建后去除重复css代码（通过配置vux-loader实现）")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("plugins: [{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'duplicate-style'")]), _vm._v("\n}]\n")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("如果你使用 "), _c('code', [_vm._v("webpack-simple")]), _vm._v(" 模板或者 webpack 配置里缺少 .vue extension 配置，请记得配置：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("resolve: {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("extensions")]), _vm._v(": ["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'.js'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'.vue'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'.json'")]), _vm._v("]\n")])])])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-94556072", module.exports)
  }
}

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1745);

/***/ }),

/***/ 930:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX 手动配置使用 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 425.d8e03739.js